<mat-card appearance="outlined" class="useradmin-contact-main-card">
  <!-- 1. SCENARIO: FORMULAR WURDE ERFOLGREICH GESENDET -->
  @if (contactFormWasSent()) {
    <mat-card
      appearance="outlined"
      class="useradmin-sub-glass-card contact-success-card">
      <div class="contact-success-box">
        <fa-icon
          [icon]="['far', 'check-circle']"
          class="success-status-icon"></fa-icon>
        <span class="success-text">
          {{ 'PRODUCT.USERADMIN.CONTACT.SENT' | translate }}
        </span>
      </div>
    </mat-card>
  } @else {
    <div class="contact-form-intro-zone">
      <h3 class="contact-form-title">
        {{ 'PRODUCT.USERADMIN.CONTACT.SUBTITLE' | translate }}
      </h3>
      <div class="contact-description-paragraphs">
        <!-- track die Zahl selbst für besseres virtuelles DOM Tracking -->
        @for (i of [1, 2, 3, 4, 5, 6]; track i) {
          <p class="contact-intro-p">
            {{ 'PRODUCT.USERADMIN.CONTACT.TEXT' + i | translate }}
          </p>
        }
      </div>
    </div>

    @let contactFormGroupValue = contactFormGroup;
    <form
      [formGroup]="contactFormGroupValue"
      (ngSubmit)="onSendContactForm()"
      class="useradmin-native-form-layout">
      <!-- Feld: Name -->
      <mat-form-field appearance="fill" class="contact-fullwidth-field">
        <mat-label>{{
          'PRODUCT.USERADMIN.CONTACT.NAME' | translate
        }}</mat-label>
        <input matInput formControlName="name" required />
      </mat-form-field>

      <!-- Feld: E-Mail -->
      <mat-form-field appearance="fill" class="contact-fullwidth-field">
        <mat-label>{{
          'PRODUCT.USERADMIN.CONTACT.EMAIL' | translate
        }}</mat-label>
        <input matInput formControlName="email" type="email" required />
      </mat-form-field>

      <!-- Feld: Telefonnummer -->
      <mat-form-field appearance="fill" class="contact-fullwidth-field">
        <mat-label>{{
          'PRODUCT.USERADMIN.CONTACT.PHONE' | translate
        }}</mat-label>
        <input matInput formControlName="phone" type="tel" required />
      </mat-form-field>

      <!-- Feld: Betreff (Dropdown-Select) -->
      <mat-form-field appearance="fill" class="contact-fullwidth-field">
        <mat-label>{{
          'PRODUCT.USERADMIN.CONTACT.SUBJECT.TITLE' | translate
        }}</mat-label>
        <mat-select formControlName="subject" required>
          @for (subject of contactSubjects(); track subject) {
            <mat-option [value]="subject">
              {{ 'PRODUCT.USERADMIN.CONTACT.SUBJECT.' + subject | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Feld: Nachrichtentext (Große Textarea) -->
      <mat-form-field
        appearance="fill"
        class="contact-fullwidth-field contact-textarea-field">
        <mat-label>{{
          'PRODUCT.USERADMIN.CONTACT.MESSAGE' | translate
        }}</mat-label>
        <textarea
          formControlName="text"
          rows="5"
          matInput
          placeholder="{{
            'PRODUCT.USERADMIN.CONTACT.MESSAGEHELP' | translate
          }}"></textarea>
      </mat-form-field>

      <!-- Sektion: Datenschutz-Einwilligung -->
      <div class="contact-privacy-consent-zone">
        <mat-checkbox
          formControlName="privacy"
          class="custom-color-checkbox privacy-checkbox">
          <span class="privacy-label-text">
            <a
              href="{{ 'PRODUCT.USERADMIN.CONTACT.PRIVACYLINK' | translate }}"
              target="_blank"
              class="privacy-link">
              {{ 'PRODUCT.USERADMIN.CONTACT.PRIVACYTITLE' | translate }}
            </a>
            {{ 'PRODUCT.USERADMIN.CONTACT.PRIVACYACCEPT' | translate }} *
          </span>
        </mat-checkbox>

        <div class="privacy-footnote-text">
          * {{ 'PRODUCT.USERADMIN.CONTACT.PRIVACYTEXT' | translate }}
        </div>
      </div>

      <!-- Aktionsleiste für Steuerungsknöpfe -->
      <mat-card-actions class="sub-card-actions-padding flex-actions-end">
        <button
          mat-flat-button
          class="btn-app-cancel"
          type="button"
          (click)="onResetContactForm()">
          {{ 'PRODUCT.USERADMIN.CANCEL' | translate }}
        </button>

        <button
          mat-flat-button
          class="btn-app-save btn-action-send"
          type="submit"
          [disabled]="contactFormGroupValue.invalid">
          <fa-icon [icon]="['far', 'paper-plane']"></fa-icon> &nbsp;
          {{ 'PRODUCT.USERADMIN.CONTACT.SEND' | translate }}
        </button>
      </mat-card-actions>
    </form>
  }
</mat-card>
